module.exports = __webpack_public_path__ + "img/occidental-hotel-4.a7abd5b4.jpg";